import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPT() {
  const articleData = {
    title: 'Por que algumas pessoas nos deixam esgotados? (A IA explica)',
    description: 'Sentindo-se emocionalmente esgotado por textos? Saiba como a IA do Toxic Detector detecta comunicação unilateral e padrões sutis de esgotamento emocional em seus relacionamentos.',
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'O que é esgotamento emocional em relacionamentos?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'O esgotamento emocional acontece quando as interações com alguém deixam você constantemente cansado, frustrado ou culpado, muitas vezes devido à comunicação unilateral ou manipuladora.'
      }
    }, {
      '@type': 'Question',
      name: 'Como as mensagens de texto podem causar esgotamento emocional?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mensagens unilaterais repetidas, culpa, engajamento inconsistente ou críticas sutis podem deixar você exausto, mesmo sem grandes conflitos.'
      }
    }, {
      '@type': 'Question',
      name: 'A IA pode detectar quem está drenando minha energia emocional?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sim. O Toxic Detector analisa padrões de texto, tom e engajamento para destacar comportamentos unilaterais, manipuladores ou desgastantes instantaneamente.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/pt/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Link copiado para a área de transferência!');
    }
  };
  return <>
      <MetaTags title="Por que algumas pessoas nos deixam esgotados? — IA explica o esgotamento emocional | ToxicDetector" description="Sentindo-se emocionalmente esgotado por textos? Saiba como a IA do Toxic Detector detecta comunicação unilateral e padrões sutis de esgotamento emocional." keywords="esgotamento emocional em relacionamentos, padrões de texto unilaterais, vampiros de energia, análise emocional IA" canonical={`https://toxicdetector.com/pt/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-8858" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-8859">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-8860">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-8861">
            <div className="flex items-center justify-between" data-id="element-8862">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-8863">
                <span className="text-2xl" data-id="element-8864">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-8865">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-8866">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-8867">
                  Scan Grátis
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Compartilhar artigo" data-id="element-8868">
                  <Share2 size={20} className="text-gray-600" data-id="element-8869" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-8870">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-8871">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8872" />
            Voltar ao Início
          </Link>

          <header className="mb-16" data-id="element-8873">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-8874">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-8875">
              <time dateTime={articleData.publishDate} data-id="element-8876">
                {new Date(articleData.publishDate).toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8877">•</span>
              <span data-id="element-8878">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-8879">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="IA analisando padrões de esgotamento emocional em mensagens de texto" className="w-full rounded-2xl shadow-lg" data-id="element-8880" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-8881">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-8882">Índice</h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-8883">
              <li data-id="element-8884">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8885">
                  O amigo "Sempre tem algo errado"
                </a>
              </li>
              <li data-id="element-8886">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8887">
                  A pessoa que só manda mensagem quando precisa de algo
                </a>
              </li>
              <li data-id="element-8888">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8889">
                  O "Dry-Texter" sem emoção
                </a>
              </li>
              <li data-id="element-8890">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8891">
                  O artista do Ghost & Return
                </a>
              </li>
              <li data-id="element-8892">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8893">
                  O culpabilizador sutil
                </a>
              </li>
              <li data-id="element-8894">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8895">
                  O falso apoiador
                </a>
              </li>
              <li data-id="element-8896">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8897">
                  O combo "Saudável-Tóxico"
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-8898">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-8899">
              Você já mandou mensagem para alguém e se sentiu cansado, irritado
              ou estranhamente culpado depois, mesmo que a conversa não tenha
              sido uma briga? Isso é{' '}
              <strong className="text-gray-900" data-id="element-8900">
                esgotamento emocional em relacionamentos
              </strong>
              , e é mais comum do que você pensa.
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-8901">
              Esses são{' '}
              <strong className="text-gray-900" data-id="element-8902">
                padrões de texto unilaterais
              </strong>{' '}
              e manipulação sutil. Nossa{' '}
              <strong className="text-gray-900" data-id="element-8903">análise de IA</strong> lê esses
              padrões instantaneamente.
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-8904">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8905">
                1️⃣ O amigo "Sempre tem algo errado"
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8906">
                Você olha para o seu telefone e sente instantaneamente:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8907">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8908">
                  "Ai meu Deus... o que agora?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8909">
                Cada mensagem é estresse, caos ou reclamações. A IA sinaliza
                isso como uma{' '}
                <strong className="text-gray-900" data-id="element-8910">
                  carga emocional unilateral
                </strong>
                .
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-8911">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8912">
                2️⃣ A pessoa que só manda mensagem quando precisa de algo
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8913">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8914">
                  <strong className="text-gray-900" data-id="element-8915">Nunca:</strong> "Como você
                  está?"
                </p>
                <p className="text-lg text-gray-700" data-id="element-8916">
                  <strong className="text-gray-900" data-id="element-8917">Sempre:</strong> "Você
                  pode...?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8918">
                A IA detecta isso como{' '}
                <strong className="text-gray-900" data-id="element-8919">
                  comunicação transacional
                </strong>
                .
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-8920">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8921">
                3️⃣ O "Dry-Texter" sem emoção
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8922">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8923">
                  "ok."
                  <br data-id="element-8924" />
                  "K."
                  <br data-id="element-8925" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8926">
                A IA captura esses{' '}
                <strong className="text-gray-900" data-id="element-8927">sinais de desconexão</strong>{' '}
                instantaneamente.
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-8928">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8929">
                4️⃣ O artista do Ghost & Return
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8930">
                Desaparece por 3 semanas. Volta como:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8931">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8932">
                  "oiii 😁"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8933">
                A IA sinaliza isso como{' '}
                <strong className="text-gray-900" data-id="element-8934">
                  engajamento inconsistente
                </strong>
                .
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-8935">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8936">
                5️⃣ O culpabilizador sutil
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8937">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8938">
                  "Acho que vou sozinho então..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8939">
                A IA marca isso como{' '}
                <strong className="text-gray-900" data-id="element-8940">manipulação passiva</strong>.
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-8941">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8942">
                6️⃣ O falso apoiador
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8943">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8944">
                  "Digo, você tende a reagir exageradamente às vezes."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8945">
                A IA detecta{' '}
                <strong className="text-gray-900" data-id="element-8946">crítica mascarada</strong>.
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-8947">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8948">
                7️⃣ O combo "Saudável-Tóxico"
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8949">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8950">
                  Alguns dias quente. Alguns dias frio.
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8951">
                A IA rotula esse padrão como{' '}
                <strong className="text-gray-900" data-id="element-8952">
                  ritmo emocional instável
                </strong>
                .
              </p>
            </section>

            <section className="mb-16" data-id="element-8953">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8954">
                Por que isso importa
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-8955">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-8956">
                  Uma vez que você vê o padrão, você pode:
                </p>
                <ul className="space-y-5" data-id="element-8957">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8958">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8959">
                      ✓
                    </span>
                    <span data-id="element-8960">Proteger sua energia</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8961">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8962">
                      ✓
                    </span>
                    <span data-id="element-8963">Estabelecer limites</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8964">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8965">
                      ✓
                    </span>
                    <span data-id="element-8966">Parar de se sentir culpado</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-8967">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-8968">
                Perguntas Frequentes
              </h2>
              <div className="space-y-5" data-id="element-8969">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-8970">
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-8971">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-8972">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-8973">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-8974">
              😮‍💨 Pare de se sentir esgotado.
              <br data-id="element-8975" />
              Comece a ver com clareza.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-8976">
              Pare de adivinhar. Envie seus textos para o Toxic Detector e
              obtenha uma pontuação de toxicidade instantânea.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-8977">
              <p className="font-bold text-2xl" data-id="element-8978">
                "⚠️ Esgotamento Emocional: Alto. Comunicação unilateral
                detectada."
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-8979">
              Escaneie seus chats agora →
            </Link>
          </div>

          <div className="mt-20" data-id="element-8980">
            <RelatedBlogPosts posts={[{
            title: 'Por que algumas pessoas nos deixam esgotados? Parte 2',
            description: 'Mais padrões sutis que drenam sua energia, incluindo sobre-explicação e sabe-tudo.',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: 'O Guia Definitivo para Textos Passivo-Agressivos',
            description: 'Detecte comportamento passivo-agressivo e manipulação oculta em mensagens de texto.',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-8981" />
          </div>

          <div className="mt-16 text-center" data-id="element-8982">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-8983">
              <Share2 size={20} data-id="element-8984" />
              Compartilhar este artigo
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-8985">
          <div className="max-w-4xl mx-auto px-6" data-id="element-8986">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-8987">
              <p className="text-gray-400 text-sm" data-id="element-8988">
                © {new Date().getFullYear()} ToxicDetector. Todos os direitos
                reservados.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}